import { AssignmentResponse } from '@/types';
import { Badge } from '../ui/badge';

interface AssignmentTagsProps {
  assignment: AssignmentResponse;
}

export function AssignmentTags({ assignment }: AssignmentTagsProps) {
  return (
    <>
      {assignment.tags ? (
        <div className='flex flex-wrap gap-1'>
          {assignment.tags.split(',').map((tag, index) => (
            <Badge key={index} variant='outline' className='text-xs'>
              {tag.trim()}
            </Badge>
          ))}
        </div>
      ) : (
        <Badge variant='outline' className='text-xs'>
          No tags yet
        </Badge>
      )}
    </>
  );
}
